import { MapPin } from 'lucide-react'

type JobLocationPulseMarkerProps = {
  label?: string
  compact?: boolean
}

export function JobLocationPulseMarker({ label, compact = false }: JobLocationPulseMarkerProps) {
  const sizeClass = compact ? 'h-10 w-10' : 'h-14 w-14'

  return (
    <div
      className="pointer-events-none relative flex flex-col items-center"
      aria-hidden={!label}
      aria-label={label ? `Job location: ${label}` : 'Job location'}
    >
      <div className={`relative flex ${sizeClass} items-center justify-center`}>
        <span className="job-location-pulse-ring job-location-pulse-ring--outer absolute inset-0 rounded-full bg-rose-500/25" />
        <span className="job-location-pulse-ring job-location-pulse-ring--inner absolute inset-1 rounded-full bg-rose-500/35" />
        <span className="job-location-pulse-core relative flex h-8 w-8 items-center justify-center rounded-full border-[3px] border-white bg-rose-500 text-white shadow-[0_8px_24px_rgba(244,63,94,0.45)]">
          <MapPin className="h-4 w-4 fill-current" strokeWidth={2.2} />
        </span>
      </div>
      {label ? (
        <div className="mt-1 max-w-[160px] rounded-full border border-white/90 bg-rose-600 px-2.5 py-0.5 text-center text-[10px] font-bold text-white shadow-md">
          <span className="line-clamp-1">{label}</span>
        </div>
      ) : null}
    </div>
  )
}
